<template>
	<div class="top" style="padding-bottom: 20px;">
		<div class="header">
			<h2 style="padding: 10px 5px;">新增用户</h2>
		</div>
		<div style="height:400px;width: 100%;" class="middle-row center">
			<div class="middle-column around" style="height:100%;width:50%;">
				<div class="input-group" style="width: 100%;">
					<span class="input-group-addon" style="width: 100px;">用户名</span>
					<input type="text" v-model="username" class="form-control" placeholder="登录账户名">
				</div>
				<div class="input-group" style="width: 100%;">
					<span class="input-group-addon" style="width: 100px;">所属街道</span>
					<select  id="select" v-model="street" class="form-control">
						<option value="东山街道">东山街道</option>
						<option value="南黎街道">南黎街道</option>
						<option value="曲阳街道">曲阳街道</option>
						<option value="渠沟镇">渠沟镇</option>
						<option value="任圩街道">任圩街道</option>
						<option value="三堤口">三堤口</option>
						<option value="相南街道">相南街道</option>
						<option value="相山东街道">相山东街道</option>
						<option value="相山西街道">相山西街道</option>
						<option value="凤凰山经济开发区">凤凰山经济开发区</option>
					</select>
				</div>
				<div class="input-group" style="width: 100%;">
					<span class="input-group-addon" style="width: 100px;">初始密码</span>
					<input type="text" v-model="password" class="form-control" placeholder="初始密码" disabled="disabled">
				</div>
				<div class="input-group" style="width: 100%;">
					<span class="input-group-addon" style="width: 100px;">用户类型</span>
					<select name="" id="select" v-model="usertype" class="form-control">
						<option v-for="(target,i) in usertypes" :value="target" :key='i'>{{target}}</option>
					</select>
				</div>
				<div class="input-group">
					<button type="button" class="btn btn-success" @click="addUser">新增用户</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {BaiduMap,BmMarker,BmCircle} from 'vue-baidu-map'
	import {util} from '../../static/util.js'
	
	export default {
		data() {
			return {
				username: '',
				usertypes: ['普通管理员','标准用户'],
				usertype: '标准用户',
				password: '123456',
				street:''
			}
		},
		methods: {
			addUser: function() {
				var login = {};
				login.username = this.username;
				login.password = this.password;
				login.usertype = this.usertype;
				login.street = this.street;
				if (util.checkLogin(login)) {
					this.$http.post(this.GLOBAL.base + 'addLogin', 
						login
					, {
						emulateJSON: true
					}).then(function(res) {
						if(res.bodyText == 'success'){
							alert('成功添加用户');
						}else{
							alert('用户名已存在，请修改');
						}
					}, function(res) {
						console.log(res);
					});
				}
			}
		},
		components: {},
	}
</script>

<style>
</style>
